// extracted by css-extract-rspack-plugin
module.exports =  {"root":"AccessDeniedView__root___N4RWm","box":"AccessDeniedView__box___QRB7N"};